import React from 'react'
import { useActions, useValues } from 'kea'

import I18n from 'lib/i18n'

import sceneLogic from '~/scenes/pages/request/logic'

const TRANSLATIONS = {
  now: I18n.t('activerecord.enums.message.start_time.now'),
  few_weeks: I18n.t('activerecord.enums.message.start_time.few_weeks'),
  just_looking: I18n.t('activerecord.enums.message.start_time.just_looking')
}

const StartTime = () => {
  const { nextPage, setStartTime } = useActions(sceneLogic)
  const { startTime } = useValues(sceneLogic)

  const saveStartTimeAndProceed = startTime => {
    setStartTime(startTime)
    nextPage()
  }

  return (
    <div className='list-choice'>
      <h1>{I18n.t('react.request.start_time.title')}</h1>
      <ul className='clickable-list'>
        {Object.keys(TRANSLATIONS).map(key => (
          <li key={key} onClick={() => saveStartTimeAndProceed(key)} className={startTime === key ? 'selected' : null}>
            {TRANSLATIONS[key]}
          </li>
        ))}
      </ul>
    </div>
  )
}

export default StartTime
